import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import Lottie, { LottieViewProps } from 'lottie-react-native';
import ErrorBoundary from './ErrorBoundary';

type LottieAnimationProps = LottieViewProps;

const LottieAnimation = forwardRef<Lottie, LottieAnimationProps>((props, ref) => {
  const lottieRef = useRef<Lottie>(null);

  useImperativeHandle(ref, () => lottieRef.current as Lottie, []);

  return (
    <ErrorBoundary>
    <Lottie
      {...props}
      ref={lottieRef}
    />
    </ErrorBoundary>
  );
});

export default LottieAnimation;
